import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Link from 'components/common/Link';
import Tooltip from 'components/common/Tooltip';
import IconArrowHeadBottom from 'components/icons/IconArrowHeadBottom';

const styles = () => ({
  linkSort: {
    height: 48,
    marginTop: -9,
    marginBottom: -9,
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  iconArrowHeadBottom: {
    width: 12,
    height: 8,
    marginLeft: 4,
  },
  iconArrowHeadTop: {
    width: 12,
    height: 8,
    marginLeft: 4,
    transform: 'rotate(180deg)',
  },
});

const SortableTableHeadCell = ({
  label,
  sortField,
  sortBy,
  sort,
  onSortingChange,
  loading,
  tooltipLabel,
  invertedSort,
  classes,
}) => {
  if (!onSortingChange) {
    return label;
  }

  const isActive = sortBy === sortField;
  const tooltipName = tooltipLabel || sortField;
  const showTop = invertedSort
    ? (sort === 'desc' || !isActive)
    : (sort === 'asc' || !isActive);
  const tooltipContent = showTop
    ? `Sort by ${tooltipName} in descending order`
    : `Sort by ${tooltipName} in ascending order`;

  return (
    <Link
      bold
      className={classes.linkSort}
      {...loading === 0 ? {
        onClick: () => onSortingChange(sortField),
      } : {}}
    >
      {label}
      <Tooltip content={tooltipContent} color="dark" placement="bottom">
        <IconArrowHeadBottom
          className={showTop ? classes.iconArrowHeadTop : classes.iconArrowHeadBottom}
        />
      </Tooltip>
    </Link>
  );
};

SortableTableHeadCell.propTypes = {
  label: PropTypes.node.isRequired,
  sortField: PropTypes.string.isRequired,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  onSortingChange: PropTypes.func,
  loading: PropTypes.number,
  tooltipLabel: PropTypes.string,
  invertedSort: PropTypes.bool,
  classes: PropTypes.shape({
    linkSort: PropTypes.string.isRequired,
    iconArrowHeadBottom: PropTypes.string.isRequired,
    iconArrowHeadTop: PropTypes.string.isRequired,
  }).isRequired,
};

SortableTableHeadCell.defaultProps = {
  sortBy: null,
  sort: null,
  onSortingChange: null,
  loading: 0,
  tooltipLabel: null,
  invertedSort: false,
};

export default withStyles(styles)(SortableTableHeadCell);



// WEBPACK FOOTER //
// ./src/components/common/SortableTableHeadCell/SortableTableHeadCell.js